import React, { useState, useEffect, useContext } from 'react'
//import api from '../api/nodeServer'
import XlsxPopulate from 'xlsx-populate'
import QRCode from 'qrcode'
import { Grid } from '@material-ui/core/';
import Typography from "@material-ui/core/Typography"
import Table from '@material-ui/core/Table'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import TableBody from "@material-ui/core/TableBody"
import Paper from '@material-ui/core/Paper'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import TextField from '@material-ui/core/TextField'
import DialogActions from '@material-ui/core/DialogActions'
import { sendGetRequest, sendPostRequest, sendDeleteRequest, sendPutRequest } from 'utils/api';
import BasicDropDown from './forms/formElements/BasicDropDown'
import DB from '../db';
import { UserContext } from '../contexts';
import { makeStyles } from '@material-ui/core/styles';
import _ from 'lodash';
import { DataGrid } from '@material-ui/data-grid';


{/* <TableCell>Business Unit</TableCell>
<TableCell>Doc No</TableCell>

<TableCell>Assignee</TableCell>
<TableCell>Department</TableCell>
<TableCell>Asset Tag</TableCell> */}


const useStyles = makeStyles({
    root: {
        width: '100%',
    },
    container: {
        maxHeight: 440,
    },
});


function MasterList(props) {
    const context = useContext(UserContext);

    const classes = useStyles();
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };


    // State Variables
    const [headerData, setHeaderData] = useState([]);
    const [specificLineData, setSpecificLineData] = useState([]);
    const [specificHeaderData, setSpecificHeaderData] = useState([]);

    const [specificBU, setSpecificBU] = useState('');
    const [specificSource, setSpecificSource] = useState('');
    const [specificAssignee, setSpecificAssignee] = useState('');
    const [specificDepartment, setSpecificDepartment] = useState('');
    const [specificAssetTag, setSpecificAssetTag] = useState('');
    const [specificRemarks, setSpecificRemarks] = useState('');

    const [assetsDialog, setAssetsDialog] = useState(false);
    const [syncDialog, setSyncDialog] = useState(false);
    const [editHeadDialog, setEditHeadDialog] = useState(false);

    const [buDialog, setBuDialog] = useState(false);
    const [businessUnits, setBusinessUnits] = useState([]);
    const [selectedBusinessUnit, setSelectedBusinessUnit] = useState(' ');

    const [tms, setTms] = useState([]);
    const [rows, setRows] = useState([{id: 0, assetDesc: '', assetTag: ''}]);
    const [famasDb, setFamasDb] = useState({
        db: new DB(),
        famas: {}
    });

    const columns = [
		{
			field: 'assetTagQR',
			headerName: 'QR',
			minWidth: 150,
			editable: false,
			renderCell: (params) => {
				return  <div>
                            <Typography>QR</Typography>
                            <img
                                src={params.value}
                                alt={'Document Number QR Code ' + params.value}
                            />
                                       
                        </div>
                       
			 
			}
		},
        {
			field: 'assetTag',
			headerName: 'Asset Tag',
			minWidth: 200,
			editable: false,
		},
		{
			field: 'assetDesc',
			headerName: 'Asset Deescription',
			minWidth: 400,
			editable: false,
		},
		{
			field: 'id',
			headerName: 'ID',
			minWidth: 100,
			editable: false,
		}
	];

    // Fetching or Getting all FAMAS Record Header from Express SQL Server, store it in on records Data,
    // loop the records data and get the assetTag and docNo to create an QRCode Image
    // and store that in final records, and set it on headerData
    async function fetchData1() {
        const headerDataResponse = await sendGetRequest('qr/famas-records-header')

        if (headerDataResponse.data) {
            const recordsData = await headerDataResponse.data.map((row) => { return row })
            console.log(recordsData);
            const finalRecords = []
            for (let i = 0; i < recordsData.length; i++) {
                const qrcode1 = await QRCode.toDataURL(recordsData[i].assetTag)
                const qrcode2 = await QRCode.toDataURL(recordsData[i].docNo)
                finalRecords.push({
                    data: recordsData[i],
                    assetTagQR: qrcode1,
                    docNoQR: qrcode2
                })
            }
            setHeaderData(finalRecords)
        }



    }

    // Gets all FAMAS record line (assets) on a spefic header_id, generate QR code, 
    // and store that on specificLineData
    async function fetchSpecificLineData(id) {
        const lineDataResults = await sendGetRequest('famas-record-line/' + id)
        const recordsData = await lineDataResults.data[0].map((row) => { return row })
        const finalRecords = []
        for (let i = 0; i < recordsData.length; i++) {
            const qrcode1 = await QRCode.toDataURL(recordsData[i].assetTag)
            const qrcode2 = await QRCode.toDataURL(recordsData[i].serialNo)
            finalRecords.push({
                data: recordsData[i],
                assetTagQR: qrcode1,
                serialQR: qrcode2
            })
        }
        console.log(finalRecords)
        setSpecificLineData(finalRecords)
        setAssetsDialog(true)
    }

    // Delets a FAMAS record line (asset) on a specific id_master 
    async function deleteSpecificLineData(id1) {
        await sendGetRequest('delete-famas-record-line/' + id1)
        console.log('DELETED' + id1)
        setAssetsDialog(false)
    }

    // Execute again fetchData1 to get all fresh new FAMAS records and place it on localstorage 
    async function syncToLocalStorage() {
        localStorage.clear()
        const lineData = await sendGetRequest('qr/famas-records-line');

        console.log(lineData);

        await lineData.data.map((row1) => {
            localStorage.setItem(row1.assetTag, JSON.stringify(row1))
        })

        await fetchData1()
        await headerData.map((row) => {
            localStorage.setItem(row.data.assetTag, JSON.stringify(row.data))
        })
        setSyncDialog(true)
    }

    // Deletes a FAMAS record header on a specific id_master
    async function deleteHeadRecord(id) {
        await sendGetRequest('delete-famas-record-header/' + id)
        fetchData1()
    }

    // Gets the data of FAMAS record header on a specific asset tag
    // and place it on headerdata, bu, source, assignee, department
    // and asset tag for the Edit Head Dialog 
    async function editHeadRecord(assetTag) {
        const result = await sendGetRequest('famas-record-header/' + assetTag)
        setSpecificHeaderData(result.data[0])
        setSpecificBU(result.data[0].businessUnit)
        setSpecificSource(result.data[0].source)
        setSpecificAssignee(result.data[0].assignee)
        setSpecificDepartment(result.data[0].department)
        setSpecificAssetTag(result.data[0].assetTag)
        setSpecificRemarks(result.data[0].remarks)
        setEditHeadDialog(true)
    }

    // Updates a FAMAS header record with the current data on specificHeaderData, specificAssetTag, 
    // specificBU, specificDepartment, and specific source on a specific id_master
    async function updateHeaderRecord() {
        const bodyRequest = {
            id: specificHeaderData.id_master,
            assetTag: specificAssetTag,
            assignee: specificAssignee,
            businessUnit: specificBU,
            department: specificDepartment,
            source: specificSource,
            updateDate: await new Date(),
            remarks: specificRemarks
        }
        const result = await sendPostRequest('update-famas-record-header/' + specificHeaderData.id_master, bodyRequest)
        if (result.data.Status === "Success") {
            fetchData1()
            setEditHeadDialog(false)
        }
    }

    useEffect(() => {
        
        if(!_.isEmpty(headerData)){
            const tempRows = [];
            console.log("TEMP ROWS", headerData);
            for(const item of headerData){

                tempRows.push({id: item.data.lineIdMaster, assetTag: item.data.assetTag, assetDesc: item.data.assetDesc, assetTagQR: item.assetTagQR});

            }
            if(tempRows.length> 0){
                console.log("TEMP ROWS", tempRows);
                setRows(tempRows);
            }
            
        }
        
        return () => {
        
        }
    }, [headerData])

    useEffect(() => {
        //fetchData1();
        const tempStringValue = localStorage.getItem('businessUnits');

        if (tempStringValue) {
            const tempItems = JSON.parse(tempStringValue);
            console.log(tempItems);
            setBusinessUnits(tempItems);
        }

        const checkDb = async () => {
            const famas = await famasDb.db.getAllFamas();
            const tempArray = Object.values(famas);
            console.log("LOADED VALUES", tempArray);

            const finalRecords = []
            for (let i = 0; i < tempArray.length; i++) {
                if (tempArray[i].assetTag) {
                    const qrcode1 = await QRCode.toDataURL(tempArray[i].assetTag)
                    const qrcode2 = await QRCode.toDataURL(tempArray[i].docNo)
                    finalRecords.push({
                        data: tempArray[i],
                        assetTagQR: qrcode1,
                        docNoQR: qrcode2
                    })
                }
            }
            setHeaderData(finalRecords)
        }
        checkDb();

        //eslint-disable-next-line
    }, [])

    // Fetches Data again on header and line and store on Xlsx
    // For Exporting data on Microsoft Excel
    function exportData() {
        XlsxPopulate.fromBlankAsync()
            .then(async function (workbook) {
                fetchData1()
                workbook.sheet(0).cell("A1").value([
                    [
                        'System ID', 'Doc No', 'Asset Tag', 'Assignee', 'Business Unit',
                        'Created By', 'Created Date', 'Department', 'Plant Site', 'Building Structure', 'Room'
                    ]
                ])
                for (var i = 0; i < headerData.length; i++) {
                    const row = [
                        headerData[i].data.headerIdMaster,
                        headerData[i].data.docNo,
                        headerData[i].data.assetTag,
                        headerData[i].data.assignee,
                        headerData[i].data.businessUnit,
                        headerData[i].data.createdBy,
                        headerData[i].data.createdDate,
                        headerData[i].data.departmentName,
                        headerData[i].data.plantSiteName,
                        headerData[i].data.buildingStructureName,
                        headerData[i].data.roomName

                    ]
                    workbook.sheet(0).cell("A" + (i + 2)).value([row])
                }
                // const lineDataResponse = await sendGetRequest('famas-records-line')
                // workbook.addSheet('line_master', 1);
                // workbook.sheet(1).cell("A1").value([
                //     [
                //         'id_master', 'header_id', 'doc_no', 'asset_tag', 'asset_desc',
                //         'uom', 'serial_no', 'acq_date', 'acq_cost', 'location_id', 
                //         'asset_stat', 'remarks'
                //     ]
                // ])
                // for (i=0; i<lineDataResponse.data[0].length; i++){
                //     const row = [
                //         lineDataResponse.data[0][i].id_master,
                //         lineDataResponse.data[0][i].header_id,
                //         lineDataResponse.data[0][i].doc_no,
                //         lineDataResponse.data[0][i].asset_tag,
                //         lineDataResponse.data[0][i].asset_desc,
                //         lineDataResponse.data[0][i].uom,
                //         lineDataResponse.data[0][i].serial_no,
                //         lineDataResponse.data[0][i].acq_date,
                //         lineDataResponse.data[0][i].acq_cost,
                //         lineDataResponse.data[0][i].location_id,
                //         lineDataResponse.data[0][i].asset_stat,
                //         lineDataResponse.data[0][i].remarks
                //     ]
                //     workbook.sheet(1).cell("A"+(i+2)).value([row])
                // }
                //workbook.sheet(0).name("header_master");
                workbook.outputAsync()
                    .then(function (blob) {
                        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                            // If IE, you must uses a different method.
                            window.navigator.msSaveOrOpenBlob(blob, "FAMAS_Records_MasterList.xlsx");
                        } else {
                            var url = window.URL.createObjectURL(blob);
                            var a = document.createElement("a");
                            document.body.appendChild(a);
                            a.href = url;
                            a.download = "FAMAS_Records_MasterList.xlsx";
                            a.click();
                            window.URL.revokeObjectURL(url);
                            document.body.removeChild(a);
                        }
                    });
            })
    }

    const getBusinessUnitData = async () => {

        context.setUserInfo({ ...context.userInfo, offline: true });

        localStorage.setItem('user', JSON.stringify({ ...context.userInfo, offline: true }));
        setBuDialog(false);

        const checkDb = async () => {
            const famas = await famasDb.db.getAllFamas();
            const tempArray = Object.values(famas);
            console.log("CAPTURED VALUES", tempArray);
        }
        checkDb();


        const headerDataResponse = await sendGetRequest('qr/famas-records-header');
        console.log("HEADER RESULTS", headerDataResponse);

        if (headerDataResponse.data) {
            for (const item of headerDataResponse.data) {
                let resFind = await famasDb.db.searchByLineIdMaster(item.lineIdMaster);
                console.log("SEARCH RESULTS", resFind);
                if (resFind.docs.length === 0) {

                    console.log("INSERTING RECORDS")
                    let res = await famasDb.db.createFamas(item);

                    if (res && res.ok) {
                        let tempItem = { ...item, _id: res.id, _rev: res.rev };
                        console.log(tempItem);
                    }
                }
            }
        }

        const tmProfiles = await sendGetRequest('/employees');

        if (tmProfiles && tmProfiles.data) {
            let tempTms = []
            for (const item of tmProfiles.data) {
                console.log(item);
                let resFind = await famasDb.db.searchTmByIdMaster(item.idMaster);
                console.log("SEARCH RESULTS", resFind);
                if (resFind.docs.length === 0) {
                    let res = await famasDb.db.createTm(item);

                    if (res && res.ok) {
                        let tempItem = { ...item, _id: res.id, _rev: res.rev };
                        console.log(tempItem);
                    }
                }
            }
        }


    }

    const genKey = () => {
        const pre = Math.random().toString(36).substr(2, 5);
        return pre + new Date().getTime();
    }

    return (
        <React.Fragment>
            <Grid
                container
                direction="row"

                spacing={3}
            >
                <Grid item xs={12} md={3} style={{ width: '100%', marginLeft: '2em' }}>
                    <Button
                        variant='contained'
                        fullWidth
                        color='primary'
                        onClick={exportData}>
                        Export Data
                    </Button>
                </Grid>

                <Grid item xs={12} md={4} style={{ width: '100%', marginLeft: '2em' }}>
                    <Button
                        variant='contained'
                        fullWidth
                        color='primary'
                        onClick={() => setBuDialog(true)}>
                        Sync to Local Storage
                    </Button>
                </Grid>

                <Grid item  xs={12} md={12}>
                    <div style={{ height: 400, width: '100%' }}>
                        <DataGrid
                            rows={rows}
                            rowHeight={125} 
                            columns={columns}
                            pageSize={10}
                            rowsPerPageOptions = {[5, 10, 50]} 
                            
                            disableSelectionOnClick
                            
                        />
                    </div>
                </Grid>
            </Grid>
            
        
            <Dialog open={assetsDialog} onClose={() => setAssetsDialog(false)}>
                <DialogTitle>FAMAS Records Assets List</DialogTitle>
                <DialogContent>

                    {specificLineData.length >= 1 && (
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell> Asset Tag </TableCell>
                                    <TableCell> Serial No </TableCell>
                                    <TableCell> UOM </TableCell>
                                    <TableCell> Description </TableCell>
                                    <TableCell> Unit Price </TableCell>
                                    <TableCell> Status </TableCell>
                                    <TableCell> Actions </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {
                                    specificLineData.map((row) => (
                                        <TableRow key={`Asset${row.data.idMaster}_${genKey()}`}>
                                            <TableCell>
                                                {row.data.assetTag}
                                                <img
                                                    src={row.assetTagQR}
                                                    alt={'Asset Tag QR Code ' + row.data.idMaster}
                                                />
                                            </TableCell>
                                            <TableCell>
                                                {row.data.serial_no}
                                                <img
                                                    src={row.serialQR}
                                                    alt={'Serial Number QR Code ' + row.data.idMaster}
                                                />
                                            </TableCell>
                                            <TableCell> {row.data.uom} </TableCell>
                                            <TableCell> {row.data.assetDesc} </TableCell>
                                            <TableCell> {row.data.acqCost} </TableCell>
                                            <TableCell> {row.data.assetStat} </TableCell>
                                            <TableCell>
                                                <Button disabled>Edit</Button>
                                                <Button onClick={() => deleteSpecificLineData(row.data.idMaster)}>Delete</Button>
                                            </TableCell>
                                        </TableRow>
                                    ))
                                }

                            </TableBody>
                        </Table>
                    )}

                    {specificLineData < 1 && (
                        <DialogContentText>
                            No Assets Data
                        </DialogContentText>
                    )}

                </DialogContent>
            </Dialog>

            <Dialog open={syncDialog} onClose={() => setSyncDialog(false)}>
                <DialogTitle>Sync Successfuly</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Updated records is successfuly synced with the local storage.
                        You can now query asset tags offline but note that
                        the data you are querying when you are offline are not
                        updated on the server. You can not also create, update,
                        and/or delete FAMAS Records when you are offline.
                    </DialogContentText>
                </DialogContent>
            </Dialog>

            <Dialog open={buDialog}>
                <DialogTitle>Choose Business Unit</DialogTitle>
                <DialogContent>
                    <DialogContentText>

                        <BasicDropDown name="businessUnit" label="Business Units" onChange={(e) => setSelectedBusinessUnit(e.target.value)} options={businessUnits} value={selectedBusinessUnit || ' '} />

                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setBuDialog(false)} color="primary">
                        Cancel
                    </Button>
                    <Button onClick={() => getBusinessUnitData()} color="primary">
                        Get Data
                    </Button>

                </DialogActions>
            </Dialog>


            <Dialog open={editHeadDialog} onClose={() => setEditHeadDialog(false)}>
                <DialogTitle>FAMAS RECORD HEAD</DialogTitle>
                <DialogContent>
                    <TextField
                        fullWidth
                        label='Business Unit'
                        value={specificBU}
                        onChange={(event) => setSpecificBU(event.target.value)} />
                    <TextField
                        fullWidth
                        label='Source'
                        value={specificSource}
                        onChange={(event) => setSpecificSource(event.target.value)} />
                    <TextField
                        fullWidth
                        label='Assignee'
                        value={specificAssignee}
                        onChange={(event) => setSpecificAssignee(event.target.value)} />
                    <TextField
                        fullWidth
                        label='Department'
                        value={specificDepartment}
                        onChange={(event) => setSpecificDepartment(event.target.value)} />
                    <TextField
                        fullWidth
                        label='AssetTag'
                        value={specificAssetTag}
                        onChange={(event) => setSpecificAssetTag(event.target.value)} />
                    <TextField
                        fullWidth
                        label='Remarks'
                        value={specificRemarks}
                        onChange={(event) => setSpecificRemarks(event.target.value)} />
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setEditHeadDialog(false)}> Cancel</Button>
                    <Button onClick={updateHeaderRecord}>Update Record</Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    )
}

export default MasterList